export default __webpack_public_path__ + "static/media/Sysorec-Logo(White).b4940a83.jpg";